
import { useState } from 'react';
import { message } from 'antd';
import dayjs from 'dayjs';
import { competitorAPI } from '../../../../../../services/api';
import type { TreeNode } from '../../types';

export const useImportAction = (skuId?: number) => {
    const [importLoading, setImportLoading] = useState<Record<string, boolean>>({});

    const handleImport = async (record: TreeNode) => {
        if (!skuId) {
            message.warning('无法获取SKU ID，请刷新页面重试');
            return;
        }
        if (!record.asin) return;

        setImportLoading(prev => ({ ...prev, [record.key]: true }));
        try {
            await competitorAPI.create({
                sku: skuId,
                asin: record.asin,
                brand: 'Unknown', // Backend scraping will update this
                first_seen: dayjs().format('YYYY-MM-DD'),
                last_seen: dayjs().format('YYYY-MM-DD'),
            });
            message.success(`ASIN ${record.asin} 已添加到竞品追踪`);
        } catch (error: any) {
            // Check if error is 'already exists'
            if (error.response?.data?.error?.includes('unique constraint')) {
                message.info('该ASIN已在追踪列表中');
            } else {
                message.error(error.userMessage || '导入失败');
            }
        } finally {
            setImportLoading(prev => ({ ...prev, [record.key]: false }));
        }
    };

    return { importLoading, handleImport };
};
